import axios from '../../axios/index.js';

export default {
    /**
     * Creates new or updates existing service appointment.
     *
     * @param data Service appointment data
     *
     * @returns {*}
     */
    createUpdateServiceAppointment(data) {
        let formData = new FormData();

        if (Object.keys(data).length !== 0 && data.constructor === Object) {
            Object.keys(data).forEach(function (key) {
                if (data[key] !== null && typeof data[key].id !== 'undefined') {
                    formData.append(key + '_id', data[key].id);
                } else if (Array.isArray(data[key]) && data[key].length) {
                    data[key].forEach((item, i) => {
                        if (typeof item === 'object' && item !== null) {
                            Object.keys(item).forEach(prop => {
                                formData.append(`${key}[${i}][${prop}]`, item[prop]);
                            });
                        } else {
                            formData.append(`${key}[${i}]`, item);
                        }
                    });
                } else if (Array.isArray(data[key])) {
                    // A workaround for sending empty arrays
                    formData.append(key + '[]', null);
                } else {
                    formData.append(key, data[key]);
                }
            });
        }

        if (!data.id) {
            return axios.post('/api/v1/service-appointments/create', formData);
        }

        return axios.post('/api/v1/service-appointments/' + data.id, formData);
    },

    /**
     * Retrieves service appointment creation information.
     *
     * @returns {*}
     */
    getCreationInformation () {
        return axios.get('/api/v1/service-appointments/info');
    },

    /**
     * Retrieves service appointment list.
     *
     * @returns {*}
     */
    getServiceAppointmentList (httpOptions) {
        return axios.get('/api/v1/service-appointments', httpOptions);
    },

    /**
     * Retrieves service appointment with given ID.
     *
     * @param id Service appointment ID
     *
     * @returns {*}
     */
    getServiceAppointment (id) {
        return axios.get('/api/v1/service-appointments/' + id);
    },

    /**
     * Get Service Appointment file upload URL.
     *
     * @param serviceProjectId Service Appointment's Project ID
     * @param fileName File name
     * @param saType Service Appointment Type id
     *
     * @returns {*}
     */
    getFileUploadUrl (serviceProjectId, fileName, saType) {
        return axios.get('/api/v1/service-appointments/file-upload-url', {
            params: {
                file_name: fileName,
                project_id: serviceProjectId,
                sa_type: saType,
            },
        });
    },

    /**
     * Void Service Appointment attachment.
     *
     * @param serviceId Service Appointment ID
     * @param attachmentId Attachment Id
     *
     * @returns {*}
     */
    voidAttachment (serviceId, attachmentId) {
        return axios.post('/api/v1/service-appointments/void-attachment/' + serviceId + '/' + attachmentId);
    },

    /**
     * Retrieves service appointment filters information.
     *
     * @returns {*}
     */
    getFiltersInformation () {
        return axios.get('/api/v1/service-appointments/filters');
    },

    /**
     * Gets service appointments list XLSX download link.
     *
     * @param options Filter options
     *
     * @returns {*}
     */
    getServiceAppointmentListToExcel (options) {
        return axios.get('/api/v1/service-appointments/xlsx', { params: options });
    },

    /**
     * Cancels service appointment.
     *
     * @param serviceAppointmentId Service Appointment ID
     * @param reason Reason for canceling
     *
     * @returns {*}
     */
    cancelServiceAppointment (serviceAppointmentId, reason) {
        return axios.post('/api/v1/service-appointments/cancel/' + serviceAppointmentId, { canceled_reason: reason });
    },

    /**
     * Starts service appointment timer
     *
     * @param serviceAppointmentId Service Appointment ID
     *
     * @returns {*}
     */
    startTimer (serviceAppointmentId) {
        return axios.post('/api/v1/service-appointments/start-service-time/' + serviceAppointmentId);
    },

    /**
     * Finishes service appointment timer
     *
     * @param serviceAppointmentId Service Appointment ID
     *
     * @returns {*}
     */
    finishTimer (serviceAppointmentId) {
        return axios.post('/api/v1/service-appointments/finish-service-time/' + serviceAppointmentId);
    },

    /**
     * Gets Waze Url
     *
     * @param {string} address
     *
     * @returns {*}
     */
    getWazeLink (address) {
        return axios.get('/api/v1/links/waze-url/' + address);
    },

    /**
     * @param {?int} currentAppointmentId
     * @param {Object} httpOptions
     *
     * @returns {*}
     */
    getNearbyAppointments (currentAppointmentId = null, httpOptions) {
        return axios.get('/api/v1/service-appointments/get-nearby/' + (currentAppointmentId == null ? '' : currentAppointmentId), httpOptions);
    },

    /**
     * @param {int} currentAppointmentId
     *
     * @returns {*}
     */
    deleteServiceAppointment (currentAppointmentId) {
        return axios.delete('/api/v1/service-appointments/' + currentAppointmentId);
    },

    /**
     * Gets location coordinates by address
     *
     * @param {string} address
     *
     * @returns {*}
     */
    getLocation (address) {
        return axios.get('/api/v1/address/coordinates/' + address);
    },
    /**
     * Get Related service appointments for order or project
     * If orderId is provided, it will fetch related service appointments for that order, default is project
     * @param orderId
     * @param projectId
     * @returns {*}
     */
    getRelatedServiceAppointments (orderId = null, projectId = null) {
        return orderId
            ? axios.get(`/api/v1/service-appointments/related-for-order/${orderId}`)
            : axios.get(`/api/v1/service-appointments/related-for-project/${projectId}`);
    },
};
